import React from 'react';
import NavBarLeft from '../../../navBar/NavBarLeft';
import NavBarTop from '../../../navBar/NavBarTop';
import DatePicker from '../card/DatePicker';
import MadeByBRB from '../../dashboard/MadeByBRB';
import RevenueChart from './card/RevenueChart';
import ProjectChart from './card/ProjectChart';

const Reports = () => {
    return (
        <main className='w-full h-screen flex justify-between'>
            <div className='w-2/12 h-full hidden lg:block'>
                <NavBarLeft/>
            </div>
            <div className='flex-1 flex flex-col'>
                <div className='h-16'>
                    <NavBarTop/>
                </div>
                <div className='p-4 h-20 lg:p-8 font-bold text-xl font-color-4 flex justify-between items-center'>
                    <h1>Einzelbericht</h1>
                    <DatePicker/>
                </div>
                <div className='flex-1 grid grid-cols-1 lg:grid-cols-9 gap-4 pb-12 px-4 lg:px-8'>
                    <div className='lg:col-span-9 border rounded-md p-4 lg:pr-8'>
                        <ProjectChart title={"Bauleiter Projektauswertung"}/>
                    </div>
                    <div
                        className='hidden lg:col-span-3 flex justify-center items-center border rounded-md p-4 lg:px-8'>
                        <RevenueChart/>
                    </div>
                </div>
                <div className='pb-4'>
                    <MadeByBRB/>
                </div>
            </div>
        </main>
    );
}

export default Reports;
